"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NRequestType = exports.ERequestType = exports.NProfileType = exports.ERegisterStatus = exports.EProfileCompareViewType = exports.EProfileAddProductType = exports.EProfileSellViewType = exports.EProfileOrdersTab = exports.EProfileProductsTab = exports.EProfileAccountTab = exports.EProfileTab = exports.EProfileType = exports.EHelpLegalInformationPages = exports.EHelpSuppliersPages = exports.EHelpCategories = exports.EInnStatus = exports.ERegisterType = exports.ECatalogDisplayViewType = exports.ECatalogDisplayItemType = exports.NTdmQueriesType = exports.ETdmQueriesType = exports.ECatalogQueryFilterType = exports.ECatalogSortType = exports.ECatalogOrderType = exports.EPageCategory = exports.EPopupModalType = exports.EPopupNotificationType = exports.EPopupMessageType = exports.EResponseType = exports.EHeaderSearchItemType = exports.EOneTimeStatus = exports.ECatalogCategoryViewType = exports.NProfileOrderStatus = exports.EProfileOrderStatus = exports.NStatusValidateProductsType = exports.EStatusValidateProductsType = exports.NLocalization = exports.ELocalization = void 0;
var ELocalization;
(function (ELocalization) {
    ELocalization["Ru"] = "ru";
    ELocalization["En"] = "en";
    ELocalization["Cn"] = "cn";
})(ELocalization || (exports.ELocalization = ELocalization = {}));
var NLocalization;
(function (NLocalization) {
    NLocalization.shortname = (lang) => {
        switch (lang) {
            case ELocalization.Ru:
                return 'РУ';
            case ELocalization.En:
                return 'EN';
            case ELocalization.Cn:
                return '中国';
        }
    };
    NLocalization.fullname = (lang, locale) => {
        if (locale) {
            const languages = {
                ru: {
                    ru: 'Русский',
                    en: 'Английский',
                    cn: 'Китайский',
                },
                en: {
                    ru: 'Russian',
                    en: 'English',
                    cn: 'Chinese',
                },
                cn: {
                    ru: '俄罗斯',
                    en: '英语',
                    cn: '中文',
                },
            };
            return languages[locale][lang];
        }
        else {
            switch (lang) {
                case ELocalization.Ru:
                    return 'Русский';
                case ELocalization.En:
                    return 'English';
                case ELocalization.Cn:
                    return '中文';
            }
        }
    };
})(NLocalization || (exports.NLocalization = NLocalization = {}));
var EStatusValidateProductsType;
(function (EStatusValidateProductsType) {
    EStatusValidateProductsType["Save"] = "SAVE";
    EStatusValidateProductsType["Publish"] = "PUBLISH";
    EStatusValidateProductsType["Rejected"] = "REJECTED";
    EStatusValidateProductsType["Archive"] = "ARCHIVE";
    EStatusValidateProductsType["Hidden"] = "HIDDEN";
    EStatusValidateProductsType["Delete"] = "DELETE";
    EStatusValidateProductsType["Suspended"] = "SUSPENDED";
    EStatusValidateProductsType["VALIDATE"] = "VALIDATE";
})(EStatusValidateProductsType || (exports.EStatusValidateProductsType = EStatusValidateProductsType = {}));
var NStatusValidateProductsType;
(function (NStatusValidateProductsType) {
    NStatusValidateProductsType.text = (value) => {
        switch (value) {
            case EStatusValidateProductsType.Save:
                return 'Сохранен';
            case EStatusValidateProductsType.Publish:
                return 'Опубликован';
            case EStatusValidateProductsType.Rejected:
                return 'Отклонен';
            case EStatusValidateProductsType.Archive:
                return 'Архивный';
            case EStatusValidateProductsType.Hidden:
                return 'Скрытый';
            case EStatusValidateProductsType.Delete:
                return 'Удален';
            case EStatusValidateProductsType.Suspended:
                return 'Приостановлен';
            case EStatusValidateProductsType.VALIDATE:
                return 'На валидации';
            default:
                return value;
        }
    };
    NStatusValidateProductsType.color = (value) => {
        switch (value) {
            case EStatusValidateProductsType.Save:
                return 'geekblue';
            case EStatusValidateProductsType.Publish:
                return 'green';
            case EStatusValidateProductsType.Rejected:
                return 'volcano';
            case EStatusValidateProductsType.Archive:
                return '';
            case EStatusValidateProductsType.Hidden:
                return 'gold';
            case EStatusValidateProductsType.Delete:
                return 'red';
            case EStatusValidateProductsType.Suspended:
                return 'magenta';
            case EStatusValidateProductsType.VALIDATE:
                return 'cyan';
            default:
                return value;
        }
    };
})(NStatusValidateProductsType || (exports.NStatusValidateProductsType = NStatusValidateProductsType = {}));
var EProfileOrderStatus;
(function (EProfileOrderStatus) {
    EProfileOrderStatus["New"] = "NEW";
    EProfileOrderStatus["InProgress"] = "IN_PROGRESS";
    EProfileOrderStatus["Formed"] = "FORMED";
    EProfileOrderStatus["Done"] = "DONE";
    EProfileOrderStatus["Canceled"] = "CANCELED";
    EProfileOrderStatus["Updated"] = "UPDATED";
})(EProfileOrderStatus || (exports.EProfileOrderStatus = EProfileOrderStatus = {}));
var NProfileOrderStatus;
(function (NProfileOrderStatus) {
    NProfileOrderStatus.color = (status) => {
        switch (status) {
            case EProfileOrderStatus.New:
                return '';
            case EProfileOrderStatus.InProgress:
                return 'warning';
            case EProfileOrderStatus.Formed:
                return 'cyan';
            case EProfileOrderStatus.Canceled:
                return 'red';
            case EProfileOrderStatus.Done:
                return 'success';
            case EProfileOrderStatus.Updated:
                return 'blue';
            default:
                return '';
        }
    };
    NProfileOrderStatus.text = (status) => {
        switch (status) {
            case EProfileOrderStatus.New:
                return 'Новый';
            // было 'Оформлен'
            case EProfileOrderStatus.InProgress:
                return 'Получен счет/предложение';
            case EProfileOrderStatus.Formed:
                return 'Сформирован';
            case EProfileOrderStatus.Done:
                return 'Завершен';
            case EProfileOrderStatus.Updated:
                return 'Изменен';
            case EProfileOrderStatus.Canceled:
                return 'Отменен';
            default:
                return '';
        }
    };
})(NProfileOrderStatus || (exports.NProfileOrderStatus = NProfileOrderStatus = {}));
var ECatalogCategoryViewType;
(function (ECatalogCategoryViewType) {
    ECatalogCategoryViewType["Card"] = "card";
    ECatalogCategoryViewType["Row"] = "row";
})(ECatalogCategoryViewType || (exports.ECatalogCategoryViewType = ECatalogCategoryViewType = {}));
var EOneTimeStatus;
(function (EOneTimeStatus) {
    EOneTimeStatus["Pending"] = "pending";
    EOneTimeStatus["Success"] = "success";
    EOneTimeStatus["Failed"] = "failed";
    EOneTimeStatus["Unknown"] = "unknown";
})(EOneTimeStatus || (exports.EOneTimeStatus = EOneTimeStatus = {}));
var EHeaderSearchItemType;
(function (EHeaderSearchItemType) {
    EHeaderSearchItemType["Category"] = "category";
    EHeaderSearchItemType["Brand"] = "brand";
    EHeaderSearchItemType["Product"] = "product";
})(EHeaderSearchItemType || (exports.EHeaderSearchItemType = EHeaderSearchItemType = {}));
var EResponseType;
(function (EResponseType) {
    EResponseType["Json"] = "json";
    EResponseType["Text"] = "text";
    EResponseType["Blob"] = "blob";
})(EResponseType || (exports.EResponseType = EResponseType = {}));
var EPopupMessageType;
(function (EPopupMessageType) {
    EPopupMessageType["Success"] = "success";
    EPopupMessageType["Error"] = "error";
    EPopupMessageType["Info"] = "info";
    EPopupMessageType["Warning"] = "warning";
})(EPopupMessageType || (exports.EPopupMessageType = EPopupMessageType = {}));
var EPopupNotificationType;
(function (EPopupNotificationType) {
    EPopupNotificationType["Success"] = "success";
    EPopupNotificationType["Info"] = "info";
    EPopupNotificationType["Warning"] = "warning";
    EPopupNotificationType["Error"] = "error";
})(EPopupNotificationType || (exports.EPopupNotificationType = EPopupNotificationType = {}));
var EPopupModalType;
(function (EPopupModalType) {
    EPopupModalType["Confirm"] = "confirm";
    EPopupModalType["Warning"] = "warning";
    EPopupModalType["Info"] = "info";
    EPopupModalType["Error"] = "error";
})(EPopupModalType || (exports.EPopupModalType = EPopupModalType = {}));
var EPageCategory;
(function (EPageCategory) {
    EPageCategory["Catalog"] = "catalog";
    EPageCategory["Profile"] = "profile";
    EPageCategory["Help"] = "help";
    EPageCategory["Manufacturer"] = "manufacturer";
    EPageCategory["Manufacturers"] = "manufacturers";
    EPageCategory["Product"] = "product";
    EPageCategory["Requests"] = "requests";
})(EPageCategory || (exports.EPageCategory = EPageCategory = {}));
var ECatalogOrderType;
(function (ECatalogOrderType) {
    ECatalogOrderType["Desc"] = "desc";
    ECatalogOrderType["Asc"] = "asc";
})(ECatalogOrderType || (exports.ECatalogOrderType = ECatalogOrderType = {}));
var ECatalogSortType;
(function (ECatalogSortType) {
    ECatalogSortType["Popular"] = "popular";
    ECatalogSortType["Price"] = "price";
    ECatalogSortType["Rate"] = "rate";
    ECatalogSortType["Name"] = "name";
})(ECatalogSortType || (exports.ECatalogSortType = ECatalogSortType = {}));
var ECatalogQueryFilterType;
(function (ECatalogQueryFilterType) {
    ECatalogQueryFilterType["Add"] = "add";
    ECatalogQueryFilterType["Remove"] = "remove";
    ECatalogQueryFilterType["Replace"] = "replace";
    ECatalogQueryFilterType["Clear"] = "clear";
    ECatalogQueryFilterType["Include"] = "include";
    ECatalogQueryFilterType["Exclude"] = "exclude";
})(ECatalogQueryFilterType || (exports.ECatalogQueryFilterType = ECatalogQueryFilterType = {}));
var ETdmQueriesType;
(function (ETdmQueriesType) {
    ETdmQueriesType["Buy"] = "BUY";
    ETdmQueriesType["Repair"] = "REPAIR";
    ETdmQueriesType["Manufacture"] = "MANUFACTURE";
})(ETdmQueriesType || (exports.ETdmQueriesType = ETdmQueriesType = {}));
var NTdmQueriesType;
(function (NTdmQueriesType) {
    NTdmQueriesType.text = (status) => {
        switch (status) {
            case ETdmQueriesType.Buy:
                return 'Закупка';
            case ETdmQueriesType.Repair:
                return 'Ремонт';
            case ETdmQueriesType.Manufacture:
                return 'Производство';
            default:
                return '';
        }
    };
})(NTdmQueriesType || (exports.NTdmQueriesType = NTdmQueriesType = {}));
var ECatalogDisplayItemType;
(function (ECatalogDisplayItemType) {
    ECatalogDisplayItemType["Catalog"] = "catalog";
    ECatalogDisplayItemType["Custom"] = "custom";
})(ECatalogDisplayItemType || (exports.ECatalogDisplayItemType = ECatalogDisplayItemType = {}));
var ECatalogDisplayViewType;
(function (ECatalogDisplayViewType) {
    ECatalogDisplayViewType["List"] = "list";
    ECatalogDisplayViewType["Grid"] = "grid";
})(ECatalogDisplayViewType || (exports.ECatalogDisplayViewType = ECatalogDisplayViewType = {}));
var ERegisterType;
(function (ERegisterType) {
    ERegisterType["Buyer"] = "buyer";
    ERegisterType["Manufacturer"] = "manufacturer";
    ERegisterType["Distributer"] = "Distributer";
})(ERegisterType || (exports.ERegisterType = ERegisterType = {}));
var EInnStatus;
(function (EInnStatus) {
    EInnStatus["Success"] = "success";
    EInnStatus["Validating"] = "validating";
    EInnStatus["Error"] = "error";
    EInnStatus["Warning"] = "warning";
    EInnStatus["Unknown"] = "";
})(EInnStatus || (exports.EInnStatus = EInnStatus = {}));
var EHelpCategories;
(function (EHelpCategories) {
    EHelpCategories["Customers"] = "customers";
    EHelpCategories["Suppliers"] = "suppliers";
    EHelpCategories["AboutProject"] = "about";
    EHelpCategories["TDM"] = "tdm";
    EHelpCategories["LegalInformation"] = "legal";
})(EHelpCategories || (exports.EHelpCategories = EHelpCategories = {}));
var EHelpSuppliersPages;
(function (EHelpSuppliersPages) {
    EHelpSuppliersPages["InstructionsForManufacturers"] = "manufacturers";
    EHelpSuppliersPages["InstructionsForTradingCompany"] = "trading";
})(EHelpSuppliersPages || (exports.EHelpSuppliersPages = EHelpSuppliersPages = {}));
var EHelpLegalInformationPages;
(function (EHelpLegalInformationPages) {
    EHelpLegalInformationPages["GeneralProvisions"] = "general";
    EHelpLegalInformationPages["UserAgreement"] = "agreement";
    EHelpLegalInformationPages["PersonalDataProcessingPolicy"] = "policy";
})(EHelpLegalInformationPages || (exports.EHelpLegalInformationPages = EHelpLegalInformationPages = {}));
var EProfileType;
(function (EProfileType) {
    EProfileType["Buyer"] = "buyer";
    EProfileType["Admin"] = "admin";
    EProfileType["Manufacturer"] = "manufacture";
    EProfileType["Distributer"] = "distributer";
    EProfileType["Unknown"] = "unknown";
})(EProfileType || (exports.EProfileType = EProfileType = {}));
var EProfileTab;
(function (EProfileTab) {
    EProfileTab["Account"] = "account";
    EProfileTab["Company"] = "company";
    EProfileTab["Products"] = "products";
    EProfileTab["Sell"] = "sell";
    EProfileTab["Staff"] = "staff";
    EProfileTab["Support"] = "support";
    EProfileTab["Notifications"] = "notifications";
    EProfileTab["Trading"] = "trading";
    EProfileTab["Basket"] = "basket";
    EProfileTab["Orders"] = "orders";
    EProfileTab["Favourites"] = "favourites";
    EProfileTab["Compare"] = "compare";
    EProfileTab["Mail"] = "mail";
    EProfileTab["TDMQueries"] = "tdm";
    EProfileTab["Api"] = "api";
})(EProfileTab || (exports.EProfileTab = EProfileTab = {}));
var EProfileAccountTab;
(function (EProfileAccountTab) {
    EProfileAccountTab["User"] = "user";
    EProfileAccountTab["Company"] = "company";
})(EProfileAccountTab || (exports.EProfileAccountTab = EProfileAccountTab = {}));
var EProfileProductsTab;
(function (EProfileProductsTab) {
    EProfileProductsTab["Add"] = "add";
    EProfileProductsTab["List"] = "list";
    EProfileProductsTab["Drafts"] = "drafts";
    EProfileProductsTab["Setup"] = "setup";
})(EProfileProductsTab || (exports.EProfileProductsTab = EProfileProductsTab = {}));
var EProfileOrdersTab;
(function (EProfileOrdersTab) {
    EProfileOrdersTab["Transactions"] = "transactions";
    EProfileOrdersTab["Requests"] = "requests";
    EProfileOrdersTab["Feedback"] = "feedback";
    EProfileOrdersTab["Lists"] = "lists";
    EProfileOrdersTab["Analytics"] = "analytics";
})(EProfileOrdersTab || (exports.EProfileOrdersTab = EProfileOrdersTab = {}));
var EProfileSellViewType;
(function (EProfileSellViewType) {
    EProfileSellViewType["Kanban"] = "kanban";
    EProfileSellViewType["List"] = "list";
    EProfileSellViewType["Archive"] = "archive";
})(EProfileSellViewType || (exports.EProfileSellViewType = EProfileSellViewType = {}));
var EProfileAddProductType;
(function (EProfileAddProductType) {
    EProfileAddProductType["Manually"] = "manually";
    EProfileAddProductType["Api"] = "api";
    EProfileAddProductType["Template"] = "template";
    EProfileAddProductType["Ai"] = "ai";
})(EProfileAddProductType || (exports.EProfileAddProductType = EProfileAddProductType = {}));
var EProfileCompareViewType;
(function (EProfileCompareViewType) {
    EProfileCompareViewType["All"] = "all";
    EProfileCompareViewType["Mismatched"] = "mismatched";
})(EProfileCompareViewType || (exports.EProfileCompareViewType = EProfileCompareViewType = {}));
var ERegisterStatus;
(function (ERegisterStatus) {
    ERegisterStatus["Success"] = "success";
    ERegisterStatus["Failed"] = "failed";
    ERegisterStatus["Bad"] = "bad";
})(ERegisterStatus || (exports.ERegisterStatus = ERegisterStatus = {}));
var NProfileType;
(function (NProfileType) {
    NProfileType.text = (status) => {
        switch (status) {
            case EProfileType.Buyer:
                return 'Покупатель';
            case EProfileType.Admin:
                return 'Администратор';
            case EProfileType.Manufacturer:
                return 'Производитель';
            case EProfileType.Distributer:
                return 'Дистрибьютор';
            case EProfileType.Unknown:
                return 'Неизвестно';
            default:
                return '';
        }
    };
    NProfileType.color = (status) => {
        switch (status) {
            case EProfileType.Buyer:
                return 'green';
            case EProfileType.Admin:
                return 'red';
            case EProfileType.Manufacturer:
                return 'yellow';
            case EProfileType.Distributer:
                return 'orange';
            case EProfileType.Unknown:
                return 'gray';
            default:
                return '';
        }
    };
})(NProfileType || (exports.NProfileType = NProfileType = {}));
var ERequestType;
(function (ERequestType) {
    ERequestType["Approve"] = "approve";
    ERequestType["Created"] = "created";
})(ERequestType || (exports.ERequestType = ERequestType = {}));
var NRequestType;
(function (NRequestType) {
    NRequestType.color = (status) => {
        switch (status) {
            case ERequestType.Approve:
                return 'green';
            case ERequestType.Created:
                return 'yellow';
            default:
                return status;
        }
    };
    NRequestType.text = (status) => {
        switch (status) {
            case ERequestType.Approve:
                return 'Подтвержден';
            case ERequestType.Created:
                return 'Создан';
            default:
                return status;
        }
    };
})(NRequestType || (exports.NRequestType = NRequestType = {}));
